import React, { ChangeEvent } from 'react'
import { useStoreActions, useStoreState } from 'store'

const options = [
  { label: '780+', value: 780 },
  { label: '760 - 779', value: 770 },
  { label: '740 - 759', value: 750 },
  { label: '720 - 739', value: 730 },
  { label: '700 - 719', value: 710 },
  { label: '680 - 699', value: 690 },
  { label: '660 - 679', value: 670 },
  { label: '640 - 659', value: 650 },
  { label: '620 - 639', value: 630 },
  { label: '580 - 619', value: 600 },
]

export default function CreditScore(props: JSX.IntrinsicAttributes & { className?: string }) {
  const { onInputTracking } = useStoreActions(actions => actions.tracking)
  const { updateDimensions } = useStoreActions(actions => actions.dimensions)
  const { creditScore } = useStoreState(state => state.dimensions.dimensions.user)

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    updateDimensions({ user: { creditScore: Number(event.target.value) } })
    onInputTracking({
      name: 'creditscore',
      type: 'CREDITSCORE',
      label: 'credit score',
      value: event.target.value,
    })
  }

  return (
    <>
      <div className={`FormControl  ${props.className}`} style={{ maxWidth: 'initial' }}>
        <label className="FormLabel" htmlFor="creditScore">
          Credit score
        </label>
        <select
          id="creditScore"
          value={creditScore}
          className="FormSelect font-circular-book type-body-one text-black"
          onChange={handleChange}
          data-testid="creditScore"
          style={{ paddingTop: '0.22222rem', height: '0' }}
        >
          {options.map((option: { value: number; label: string }) => (
            <option key={`credit-score-option-${option.label}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="FormSelect-arrow Icon Icon--xs">
          <svg
            className="Icon-glyph"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="-1 -2 8 8"
            aria-hidden="true"
          >
            <title>Arrow icon</title>
            <path d="M.707 0L0 .697 3.354 4 6.707.697 6 0 3.359 2.602z" fillRule="evenodd" />
          </svg>
        </span>
      </div>
    </>
  )
}
